import localforage from "localforage"

const CACHE_INDEX_KEY = "__http_cache_index__"

async function removeFromIndex(key) {
  try {
    const index = await localforage.getItem(CACHE_INDEX_KEY)
    if (!Array.isArray(index)) return
    const nextIndex = index.filter(entry => entry.key !== key)
    if (nextIndex.length !== index.length) {
      await localforage.setItem(CACHE_INDEX_KEY, nextIndex)
    }
  } catch (error) {
    // ignore storage errors
  }
}

function shouldRemoveKey(storageKey, searchKey) {
  if (storageKey.indexOf("data/") === 0) {
    const suffix = storageKey.split("data/")[1]
    return suffix.indexOf(searchKey) === 0
  }
  if (storageKey.indexOf("api/") !== -1) {
    const suffix = storageKey.split("api/")[1]
    return suffix.indexOf(searchKey) === 0
  }
  return false
}

async function removeKey(key) {
  try {
    await localforage.removeItem(key)
    await removeFromIndex(key)
  } catch (error) {
    // ignore storage errors
  }
}

export default {
  async findAndRemove(keyToSearch) {
    try {
      const normalized = keyToSearch.split("?")[0].toLowerCase()
      const keys = await localforage.keys()
      const keysToRemove = keys.filter(key => shouldRemoveKey(key, normalized))
      await Promise.all(keysToRemove.map(removeKey))
    } catch (error) {
      // ignore storage errors
    }
  },
  async remove(key) {
    await removeKey(key)
  }
}
